import { render, staticRenderFns } from "./shareDialog.vue?vue&type=template&id=66f6f66c&scoped=true&lang=pug"
import script from "./shareDialog.vue?vue&type=script&lang=js"
export * from "./shareDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f6f66c",
  null
  
)

export default component.exports